import React from "react";
import "./App.css";
import "./index.css";
import "./components/Common_Component/Common_Css/Common_Css.css";
import "./components/Common_Component/Common_Css/Form_Css.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import AboutUs from "./components/about_us/AboutUs";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import Terms_Conditions from "./components/Terms_Conditions/Terms_Conditions";
import Privacy_Policy from "./components/Privacy_Policy/Privacy_Policy";
import Faq from "./components/Faq/Faq";
import Eligibilty_Calculator from "./components/Eligibilty_Calculator/Eligibilty_Calculator";
import TermLifeInsuarance from "./components/TermLifeInsuarance/TermLifeInsuarance";
import LoanCompare from "./components/LoanCompare/LoanCompare";
import LoanCalculator from "./components/LoanCalculator/LoanCalculator";

import Plan_Purchase from "./components/Plan_Purchase/Plan_Purchase";
import Plan_Compare_Page from "./components/Plan_Compare_Page/Plan_Compare_Page";
import Blogs from "./components/Blogs/Blogs";
import BlogDetailsPage from "./components/Blogs/BlogDetailsPage/BlogDetailsPage";
import ContactUs from "./components/ContactUs/ContactUs";
import AppContext, { Context } from "./utils/context";
import Thank_you from "./components/Thank-you/Thank_you";
import BlogDetailsPage1 from "./components/Blogs/BlogDetailsPage/BlogDetailsPage1";
import BlogDetailsPages2 from "./components/Blogs/BlogDetailsPage/BlogDetailsPages2";


function App() {
  return (
    <>
      <AppContext>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/terms-conditions" element={<Terms_Conditions />} />
          <Route path="/privacy-policy" element={<Privacy_Policy />} />
          <Route path="/faq" element={<Faq />} />
          <Route
            path="/eligibilty-calculator"
            element={<Eligibilty_Calculator />}
          />
          <Route path="/term-lifeinsurance" element={<TermLifeInsuarance />} />
          <Route path="/loan-compare" element={<LoanCompare />} />
          <Route path="/loan-calculator" element={<LoanCalculator />} />
          <Route path="/plan-purchase" element={<Plan_Purchase />} />
          <Route path="/plan-compare" element={<Plan_Compare_Page />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blog-details" element={<BlogDetailsPage />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/thank-you" element={<Thank_you />} />
          <Route path="/blog-1" element={<BlogDetailsPage1 />} />
          <Route path="/blog-2" element={<BlogDetailsPages2 />} />
          
        </Routes>
        <Footer />
      </AppContext>
    </>
  );
}

export default App;
